module.exports = __webpack_public_path__ + "static/media/permablok-3-plus.89af8d61.svg";